import { useEffect, useRef, useState } from 'react';
import { isEmpty } from 'lodash';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useDataService } from '../../../services/ApiDataService';
import { useNavigate } from '../../../utilities/PgmUtilities';
import { useEntityIdParam } from '../AdminLinkUtils';

const testNotFound = (id) => i18n._(t`For service test with id: <b>${id}</b>, can not be found.`);

const typeNotFound = (id) => i18n._(t`For service test with id: <b>${id}</b>, can not find related type.`);

/**
 * Service Tests Id Page
 *
 * Routes: /plm/{plmId}/service-tests/:_id
 * Routes: /plm/{plmId}/service-tests/tests/:_id
 *
 * After find type, would to navigate to new url route
 * /admin/service-tests/:type/tests/:_id
 */
export default function TestIdPage() {
    const id = useEntityIdParam();
    const navigate = useNavigate();
    const [type, setType] = useState(null);
    const [error, setError] = useState(null);
    const hasFetchedRef = useRef(false);
    const dataService = useDataService();

    useEffect(() => {
        if (hasFetchedRef.current) {
            return;
        }

        let cancelled = false;

        dataService
            .get(`/ngp/v2/service-tests/${id}`, { includedDeletedOnes: true })
            .then((result) => {
                if (cancelled) {
                    return;
                }

                hasFetchedRef.current = true;
                setType(result?.type);
            })
            .catch((err) => {
                hasFetchedRef.current = true;
                setError(err?.message);
            });

        return () => {
            cancelled = true;
        };
    }, [id, dataService]);

    useEffect(() => {
        if (isEmpty(type)) {
            return;
        }

        navigate(`/admin/service-tests/${type}/tests/${id}`, {
            replace: true,
        });
    }, [id, type, navigate]);

    if (!hasFetchedRef.current) {
        return <LinearProgress />;
    }

    if (!isEmpty(error)) {
        return (
            <Typography variant="subtitle2">
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: testNotFound(id) }} />
            </Typography>
        );
    }

    if (isEmpty(type)) {
        return (
            <Typography variant="subtitle2">
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: typeNotFound(id) }} />
            </Typography>
        );
    }

    return null;
}
